
import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncInboundFaxModule as MncInboundFaxModule } from '@app/mnc-inbound-fax.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('INBOUNDFAX UI Version:', {
  buildNumber,
  commit,
});

platformBrowserDynamic()
  .bootstrapModule(MncInboundFaxModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
